"use strict";
(self["webpackChunkbranch_basics"] = self["webpackChunkbranch_basics"] || []).push([[6333],{

/***/ 6333:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ DropdownSelect)
/* harmony export */ });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4692);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);


function DropdownSelect({ wrapper }) {
  let $wrapper = jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper);
  let settings = {
    selectedContent: '[data-hook="dropdown-select-content"]',
    dropdownTrigger: '[data-hook="dropdown-trigger"]',
    dropdownMenu: '[data-hook="dropdown-menu"]',
    dropdownListItem: '[data-hook="dropdown-list-item"]',

    externalDownloadItem: '[data-external-download]'
  }

  let $config = {
    $selectedContent: $wrapper.find(settings.selectedContent),
    $dropdownTrigger: $wrapper.find(settings.dropdownTrigger),
    $dropdownMenu: $wrapper.find(settings.dropdownMenu),
    $dropdownListItems: $wrapper.find(settings.dropdownListItem),

    $externalDownloaders: $wrapper.find(settings.externalDownloadItem)
  }

  ;(function init() {
    if ($config.$dropdownTrigger.length === 0) return

    initializeEventListeners();
  })()

  function initializeEventListeners() {
    $config.$dropdownTrigger.on('click', toggleDropdown);
    $config.$dropdownListItems.on('click', toggleDropdown);

    // File (PDF) Downloader
    $config.$externalDownloaders.on('click', handlExternalDownloadLink);
  }

  function toggleDropdown() {
    $wrapper.toggleClass('active');
  }


  function handlExternalDownloadLink() {
    $wrapper.addClass('downloaded');
    let revertText = $config.$selectedContent.text();
    $config.$selectedContent.text('Downloaded');

    setTimeout(() => {
      $wrapper.removeClass('downloaded');
      $config.$selectedContent.text(revertText);
    }, 6000);
  }

};


/***/ })

}]);